import { Environment } from 'sharedModels/environment';
import { brandEnvironment } from './brandEnvironment';

export const environment: Environment = {
    ...brandEnvironment,
    production: true,
    debugDrawer: 'false',
};
